const hasValidAnswer = (question, answer) => {
  const questionOption = question.options.find(i => i.id === answer.answerId)

  if (!questionOption) {
    return false
  }

  switch (questionOption.kind) {
    case 'number':
      return !isNaN(answer.extra)
    case 'text':
      return !!answer.extra && `${answer.extra}`.length > 0
    default:
      return true
  }
}

const quizCompleted = (questions, answers) =>
  questions.every(question =>
    hasValidAnswer(
      question,
      (answers || []).find(i => i.questionId === question.id) || {},
    ),
  )

const questions = { hasValidAnswer, quizCompleted }

export default questions
